module.exports = __webpack_public_path__ + "img/confetti.3ffa8f72.svg";